var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Output-svg",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "out",
    transform: "translate(-559.000000, -105.000000)",
    fill: "#2464eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572.163179,108.773986 C571.821387,108.744485 571.549732,108.4688 571.549732,108.114784 L571.549732,106.853349 C571.549732,106.562405 571.226709,106.396587 571.000494,106.571561 L567.254616,109.483035 C566.915787,109.746512 566.9148,110.270414 567.253628,110.533892 L571.000494,113.454521 C571.225721,113.630512 571.549732,113.464694 571.549732,113.17375 L571.549732,112.009974 C571.549732,111.604077 571.903377,111.288718 572.293573,111.348738 C575.032846,111.777016 577.041119,114.496222 576.41483,117.550116 C576.289375,118.162523 576.04933,118.736273 575.72038,119.247968 C575.360808,119.808492 575.504044,120.561284 576.036488,120.949888 L576.057233,120.96413 C576.601531,121.361889 577.377971,121.249987 577.749398,120.678272 C578.537692,119.461598 579,118.001792 579,116.429067 C579,112.402647 575.992036,109.100535 572.163179,108.773986 Z M569.836821,125.226014 C570.178613,125.255515 570.450268,125.5312 570.450268,125.885216 L570.450268,127.146651 C570.450268,127.437595 570.773291,127.603413 570.999506,127.428439 L574.745384,124.516965 C575.084213,124.253488 575.0852,123.729586 574.746372,123.466108 L570.999506,120.545479 C570.774279,120.369488 570.450268,120.535306 570.450268,120.82625 L570.450268,121.990026 C570.450268,122.395923 570.096623,122.711282 569.706427,122.651262 C566.967154,122.222984 564.958881,119.503778 565.58517,116.449884 C565.710625,115.837477 565.95067,115.263727 566.27962,114.752032 C566.639192,114.191508 566.495956,113.438716 565.963512,113.050112 L565.942767,113.03587 C565.398469,112.638111 564.622029,112.750013 564.250602,113.321728 C563.462308,114.538402 563,115.998208 563,117.570933 C563,121.597353 566.007964,124.899465 569.836821,125.226014 Z",
    id: "sync",
    transform: "translate(571.000000, 117.000000) scale(-1, 1) translate(-571.000000, -117.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.72faf30ba468087b6139a8e4b5485775.svg";
export { ForwardRef as ReactComponent };